@file:OptIn(InternalResourceApi::class)

package portalvv.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/portalvv.shared.generated.resources/"

@delegate:ResourceContentHash(21_712_755)
internal val Res.string.operational_supplier_title_add: StringResource by lazy {
      StringResource("string:operational_supplier_title_add", "operational_supplier_title_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50327, 66),
      ))
    }

@delegate:ResourceContentHash(265_005_991)
internal val Res.string.operational_supplier_title_edit: StringResource by lazy {
      StringResource("string:operational_supplier_title_edit", "operational_supplier_title_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50394, 63),
      ))
    }

@delegate:ResourceContentHash(-205_408_843)
internal val Res.string.operational_supplier_use_existing: StringResource by lazy {
      StringResource("string:operational_supplier_use_existing", "operational_supplier_use_existing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50458, 77),
      ))
    }

@delegate:ResourceContentHash(-1_044_404_365)
internal val Res.string.operational_supplier_use_new: StringResource by lazy {
      StringResource("string:operational_supplier_use_new", "operational_supplier_use_new", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50536, 72),
      ))
    }

@delegate:ResourceContentHash(1_597_430_291)
internal val Res.string.operational_table_faturamento: StringResource by lazy {
      StringResource("string:operational_table_faturamento", "operational_table_faturamento", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50609, 53),
      ))
    }

@delegate:ResourceContentHash(-174_985_268)
internal val Res.string.operational_total_label: StringResource by lazy {
      StringResource("string:operational_total_label", "operational_total_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50663, 39),
      ))
    }

@delegate:ResourceContentHash(1_350_968_497)
internal val Res.string.operational_type_label: StringResource by lazy {
      StringResource("string:operational_type_label", "operational_type_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50703, 38),
      ))
    }

@delegate:ResourceContentHash(2_063_658_602)
internal val Res.string.operational_type_planned: StringResource by lazy {
      StringResource("string:operational_type_planned", "operational_type_planned", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50742, 44),
      ))
    }

@delegate:ResourceContentHash(-1_670_186_359)
internal val Res.string.operational_type_real: StringResource by lazy {
      StringResource("string:operational_type_real", "operational_type_real", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50787, 37),
      ))
    }

@delegate:ResourceContentHash(947_449_837)
internal val Res.string.operational_under_construction: StringResource by lazy {
      StringResource("string:operational_under_construction", "operational_under_construction", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50825, 58),
      ))
    }

@delegate:ResourceContentHash(-2_027_207)
internal val Res.string.operational_units_empty: StringResource by lazy {
      StringResource("string:operational_units_empty", "operational_units_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50884, 67),
      ))
    }

@delegate:ResourceContentHash(2_062_432_091)
internal val Res.string.operational_updated_info: StringResource by lazy {
      StringResource("string:operational_updated_info", "operational_updated_info", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50952, 84),
      ))
    }

@delegate:ResourceContentHash(-1_964_518_926)
internal val Res.string.operational_week_format: StringResource by lazy {
      StringResource("string:operational_week_format", "operational_week_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51037, 47),
      ))
    }

@delegate:ResourceContentHash(1_469_936_197)
internal val Res.string.orgchart_add: StringResource by lazy {
      StringResource("string:orgchart_add", "orgchart_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51245, 32),
      ))
    }

@delegate:ResourceContentHash(1_151_430_244)
internal val Res.string.orgchart_add_company: StringResource by lazy {
      StringResource("string:orgchart_add_company", "orgchart_add_company", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51085, 52),
      ))
    }

@delegate:ResourceContentHash(1_485_689_386)
internal val Res.string.orgchart_add_director: StringResource by lazy {
      StringResource("string:orgchart_add_director", "orgchart_add_director", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51138, 53),
      ))
    }

@delegate:ResourceContentHash(947_098_975)
internal val Res.string.orgchart_add_manager: StringResource by lazy {
      StringResource("string:orgchart_add_manager", "orgchart_add_manager", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51192, 52),
      ))
    }

@delegate:ResourceContentHash(1_491_262_751)
internal val Res.string.orgchart_back_to_current: StringResource by lazy {
      StringResource("string:orgchart_back_to_current", "orgchart_back_to_current", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51278, 68),
      ))
    }

@delegate:ResourceContentHash(515_583_929)
internal val Res.string.orgchart_cancel: StringResource by lazy {
      StringResource("string:orgchart_cancel", "orgchart_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51347, 35),
      ))
    }

@delegate:ResourceContentHash(2_528_383)
internal val Res.string.orgchart_cell_evt: StringResource by lazy {
      StringResource("string:orgchart_cell_evt", "orgchart_cell_evt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51383, 29),
      ))
    }

@delegate:ResourceContentHash(2_570_595)
internal val Res.string.orgchart_cell_loj: StringResource by lazy {
      StringResource("string:orgchart_cell_loj", "orgchart_cell_loj", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51413, 29),
      ))
    }

@delegate:ResourceContentHash(2_631_656)
internal val Res.string.orgchart_cell_tra: StringResource by lazy {
      StringResource("string:orgchart_cell_tra", "orgchart_cell_tra", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51443, 29),
      ))
    }

@delegate:ResourceContentHash(2_646_801)
internal val Res.string.orgchart_cell_upr: StringResource by lazy {
      StringResource("string:orgchart_cell_upr", "orgchart_cell_upr", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51473, 29),
      ))
    }

@delegate:ResourceContentHash(-572_994_827)
internal val Res.string.orgchart_change_company_added: StringResource by lazy {
      StringResource("string:orgchart_change_company_added", "orgchart_change_company_added", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51503, 105),
      ))
    }

@delegate:ResourceContentHash(-1_776_414_173)
internal val Res.string.orgchart_change_company_linked_director: StringResource by lazy {
      StringResource("string:orgchart_change_company_linked_director", "orgchart_change_company_linked_director", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51722, 107),
      ))
    }

@delegate:ResourceContentHash(2_106_197_327)
internal val Res.string.orgchart_change_company_linked_directors: StringResource by lazy {
      StringResource("string:orgchart_change_company_linked_directors", "orgchart_change_company_linked_directors", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51609, 112),
      ))
    }

@delegate:ResourceContentHash(-226_678_545)
internal val Res.string.orgchart_change_company_linked_organogram: StringResource by lazy {
      StringResource("string:orgchart_change_company_linked_organogram", "orgchart_change_company_linked_organogram", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51830, 125),
      ))
    }

@delegate:ResourceContentHash(-865_004_575)
internal val Res.string.orgchart_change_company_managed: StringResource by lazy {
      StringResource("string:orgchart_change_company_managed", "orgchart_change_company_managed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52201, 87),
      ))
    }

@delegate:ResourceContentHash(959_813_227)
internal val Res.string.orgchart_change_company_managed_in_director: StringResource by lazy {
      StringResource("string:orgchart_change_company_managed_in_director", "orgchart_change_company_managed_in_director", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52081, 119),
      ))
    }

@delegate:ResourceContentHash(2_009_405_714)
internal val Res.string.orgchart_change_company_managed_in_directors: StringResource by lazy {
      StringResource("string:orgchart_change_company_managed_in_directors", "orgchart_change_company_managed_in_directors", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51956, 124),
      ))
    }

@delegate:ResourceContentHash(561_244_138)
internal val Res.string.orgchart_change_company_removed: StringResource by lazy {
      StringResource("string:orgchart_change_company_removed", "orgchart_change_company_removed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52289, 91),
      ))
    }

@delegate:ResourceContentHash(-1_251_810_976)
internal val Res.string.orgchart_change_company_stopped_managed: StringResource by lazy {
      StringResource("string:orgchart_change_company_stopped_managed", "orgchart_change_company_stopped_managed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52646, 95),
      ))
    }

@delegate:ResourceContentHash(-1_891_083_107)
internal val Res.string.orgchart_change_company_stopped_managed_in_director: StringResource by
    lazy {
      StringResource("string:orgchart_change_company_stopped_managed_in_director", "orgchart_change_company_stopped_managed_in_director", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52514, 131),
      ))
    }

@delegate:ResourceContentHash(-1_019_388_222)
internal val Res.string.orgchart_change_company_stopped_managed_in_directors: StringResource by
    lazy {
      StringResource("string:orgchart_change_company_stopped_managed_in_directors", "orgchart_change_company_stopped_managed_in_directors", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52381, 132),
      ))
    }

@delegate:ResourceContentHash(733_404_236)
internal val Res.string.orgchart_change_company_unlinked_director: StringResource by lazy {
      StringResource("string:orgchart_change_company_unlinked_director", "orgchart_change_company_unlinked_director", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52742, 113),
      ))
    }

@delegate:ResourceContentHash(554_252_936)
internal val Res.string.orgchart_change_company_unlinked_organogram: StringResource by lazy {
      StringResource("string:orgchart_change_company_unlinked_organogram", "orgchart_change_company_unlinked_organogram", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52856, 127),
      ))
    }

@delegate:ResourceContentHash(-1_724_458_618)
internal val Res.string.orgchart_change_director_added: StringResource by lazy {
      StringResource("string:orgchart_change_director_added", "orgchart_change_director_added", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52984, 122),
      ))
    }

@delegate:ResourceContentHash(561_244_138)
internal val Res.string.orgchart_change_director_removed: StringResource by lazy {
      StringResource("string:orgchart_change_director_removed", "orgchart_change_director_removed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53107, 92),
      ))
    }

@delegate:ResourceContentHash(-33_133_108)
internal val Res.string.orgchart_change_manager_added: StringResource by lazy {
      StringResource("string:orgchart_change_manager_added", "orgchart_change_manager_added", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53200, 121),
      ))
    }

@delegate:ResourceContentHash(561_244_138)
internal val Res.string.orgchart_change_manager_removed: StringResource by lazy {
      StringResource("string:orgchart_change_manager_removed", "orgchart_change_manager_removed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53322, 91),
      ))
    }

@delegate:ResourceContentHash(1_676_977_115)
internal val Res.string.orgchart_change_manager_responds: StringResource by lazy {
      StringResource("string:orgchart_change_manager_responds", "orgchart_change_manager_responds", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53519, 96),
      ))
    }

@delegate:ResourceContentHash(-1_648_688_055)
internal val Res.string.orgchart_change_manager_responds_all: StringResource by lazy {
      StringResource("string:orgchart_change_manager_responds_all", "orgchart_change_manager_responds_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53414, 104),
      ))
    }

@delegate:ResourceContentHash(-1_394_264_509)
internal val Res.string.orgchart_change_manager_stopped: StringResource by lazy {
      StringResource("string:orgchart_change_manager_stopped", "orgchart_change_manager_stopped", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53616, 95),
      ))
    }

@delegate:ResourceContentHash(1_766_707_048)
internal val Res.string.orgchart_changes_draft_title: StringResource by lazy {
      StringResource("string:orgchart_changes_draft_title", "orgchart_changes_draft_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53712, 68),
      ))
    }

@delegate:ResourceContentHash(1_581_030_058)
internal val Res.string.orgchart_changes_info_title: StringResource by lazy {
      StringResource("string:orgchart_changes_info_title", "orgchart_changes_info_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53781, 67),
      ))
    }

@delegate:ResourceContentHash(1_693_140_584)
internal val Res.string.orgchart_close: StringResource by lazy {
      StringResource("string:orgchart_close", "orgchart_close", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53849, 30),
      ))
    }

@delegate:ResourceContentHash(1_052_756_817)
internal val Res.string.orgchart_company_actions: StringResource by lazy {
      StringResource("string:orgchart_company_actions", "orgchart_company_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53880, 56),
      ))
    }

@delegate:ResourceContentHash(117_758_081)
internal val Res.string.orgchart_comparing: StringResource by lazy {
      StringResource("string:orgchart_comparing", "orgchart_comparing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53937, 62),
      ))
    }

@delegate:ResourceContentHash(1_976_861_733)
internal val Res.string.orgchart_confirm: StringResource by lazy {
      StringResource("string:orgchart_confirm", "orgchart_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54000, 36),
      ))
    }

@delegate:ResourceContentHash(128_259_271)
internal val Res.string.orgchart_copy_company: StringResource by lazy {
      StringResource("string:orgchart_copy_company", "orgchart_copy_company", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54037, 49),
      ))
    }

@delegate:ResourceContentHash(-76_071_998)
internal val Res.string.orgchart_copy_manager: StringResource by lazy {
      StringResource("string:orgchart_copy_manager", "orgchart_copy_manager", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54087, 49),
      ))
    }

@delegate:ResourceContentHash(1_825_394_582)
internal val Res.string.orgchart_copy_support: StringResource by lazy {
      StringResource("string:orgchart_copy_support", "orgchart_copy_support", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54137, 105),
      ))
    }

@delegate:ResourceContentHash(1_883_253_487)
internal val Res.string.orgchart_copy_to: StringResource by lazy {
      StringResource("string:orgchart_copy_to", "orgchart_copy_to", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54313, 40),
      ))
    }

@delegate:ResourceContentHash(1_235_266_766)
internal val Res.string.orgchart_copy_to_director: StringResource by lazy {
      StringResource("string:orgchart_copy_to_director", "orgchart_copy_to_director", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54243, 69),
      ))
    }

@delegate:ResourceContentHash(-456_592_170)
internal val Res.string.orgchart_create_version: StringResource by lazy {
      StringResource("string:orgchart_create_version", "orgchart_create_version", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54354, 51),
      ))
    }

@delegate:ResourceContentHash(-459_850_243)
internal val Res.string.orgchart_director_actions: StringResource by lazy {
      StringResource("string:orgchart_director_actions", "orgchart_director_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54406, 61),
      ))
    }

@delegate:ResourceContentHash(747_748_390)
internal val Res.string.orgchart_director_subtitle: StringResource by lazy {
      StringResource("string:orgchart_director_subtitle", "orgchart_director_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54468, 46),
      ))
    }

@delegate:ResourceContentHash(-2_051_160_500)
internal val Res.string.orgchart_discard_action: StringResource by lazy {
      StringResource("string:orgchart_discard_action", "orgchart_discard_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54515, 43),
      ))
    }

@delegate:ResourceContentHash(-1_729_010_654)
internal val Res.string.orgchart_discard_draft: StringResource by lazy {
      StringResource("string:orgchart_discard_draft", "orgchart_discard_draft", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54698, 54),
      ))
    }

@delegate:ResourceContentHash(729_228_421)
internal val Res.string.orgchart_discard_draft_msg: StringResource by lazy {
      StringResource("string:orgchart_discard_draft_msg", "orgchart_discard_draft_msg", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54559, 138),
      ))
    }

@delegate:ResourceContentHash(866_637_911)
internal val Res.string.orgchart_empty_result: StringResource by lazy {
      StringResource("string:orgchart_empty_result", "orgchart_empty_result", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54753, 69),
      ))
    }

@delegate:ResourceContentHash(-1_638_939_969)
internal val Res.string.orgchart_export: StringResource by lazy {
      StringResource("string:orgchart_export", "orgchart_export", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54823, 35),
      ))
    }

@delegate:ResourceContentHash(1_381_284_192)
internal val Res.string.orgchart_legend_events: StringResource by lazy {
      StringResource("string:orgchart_legend_events", "orgchart_legend_events", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54859, 46),
      ))
    }

@delegate:ResourceContentHash(-770_111_946)
internal val Res.string.orgchart_legend_kitchens: StringResource by lazy {
      StringResource("string:orgchart_legend_kitchens", "orgchart_legend_kitchens", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54906, 60),
      ))
    }

@delegate:ResourceContentHash(1_603_140_714)
internal val Res.string.orgchart_legend_stores: StringResource by lazy {
      StringResource("string:orgchart_legend_stores", "orgchart_legend_stores", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54967, 42),
      ))
    }

@delegate:ResourceContentHash(-1_794_245_564)
internal val Res.string.orgchart_legend_transported: StringResource by lazy {
      StringResource("string:orgchart_legend_transported", "orgchart_legend_transported", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55010, 55),
      ))
    }

@delegate:ResourceContentHash(410_413_010)
internal val Res.string.orgchart_manage_supervisors: StringResource by lazy {
      StringResource("string:orgchart_manage_supervisors", "orgchart_manage_supervisors", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55066, 51),
      ))
    }

@delegate:ResourceContentHash(576_787_535)
internal val Res.string.orgchart_manager_actions: StringResource by lazy {
      StringResource("string:orgchart_manager_actions", "orgchart_manager_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55118, 56),
      ))
    }

@delegate:ResourceContentHash(725_483_027)
internal val Res.string.orgchart_mark_all_companies: StringResource by lazy {
      StringResource("string:orgchart_mark_all_companies", "orgchart_mark_all_companies", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55175, 67),
      ))
    }

@delegate:ResourceContentHash(-675_071_349)
internal val Res.string.orgchart_move_companies_too: StringResource by lazy {
      StringResource("string:orgchart_move_companies_too", "orgchart_move_companies_too", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55243, 67),
      ))
    }

@delegate:ResourceContentHash(1_123_705_393)
internal val Res.string.orgchart_new_version: StringResource by lazy {
      StringResource("string:orgchart_new_version", "orgchart_new_version", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55381, 44),
      ))
    }

@delegate:ResourceContentHash(-1_193_223_952)
internal val Res.string.orgchart_new_version_body: StringResource by lazy {
      StringResource("string:orgchart_new_version_body", "orgchart_new_version_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55311, 69),
      ))
    }

@delegate:ResourceContentHash(1_892_574_514)
internal val Res.string.orgchart_no_changes_previous: StringResource by lazy {
      StringResource("string:orgchart_no_changes_previous", "orgchart_no_changes_previous", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55426, 108),
      ))
    }

@delegate:ResourceContentHash(880_301_462)
internal val Res.string.orgchart_no_companies: StringResource by lazy {
      StringResource("string:orgchart_no_companies", "orgchart_no_companies", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55535, 45),
      ))
    }

@delegate:ResourceContentHash(1_214_560_586)
internal val Res.string.orgchart_no_director_option: StringResource by lazy {
      StringResource("string:orgchart_no_director_option", "orgchart_no_director_option", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55581, 51),
      ))
    }

@delegate:ResourceContentHash(1_007_876_932)
internal val Res.string.orgchart_no_previous: StringResource by lazy {
      StringResource("string:orgchart_no_previous", "orgchart_no_previous", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55633, 84),
      ))
    }

@delegate:ResourceContentHash(1_386_823_236)
internal val Res.string.orgchart_not_found_company: StringResource by lazy {
      StringResource("string:orgchart_not_found_company", "orgchart_not_found_company", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55718, 62),
      ))
    }

@delegate:ResourceContentHash(1_908_407_576)
internal val Res.string.orgchart_not_found_director: StringResource by lazy {
      StringResource("string:orgchart_not_found_director", "orgchart_not_found_director", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55781, 63),
      ))
    }

@delegate:ResourceContentHash(1_369_817_165)
internal val Res.string.orgchart_not_found_manager: StringResource by lazy {
      StringResource("string:orgchart_not_found_manager", "orgchart_not_found_manager", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55845, 62),
      ))
    }

@delegate:ResourceContentHash(32_997_742)
internal val Res.string.orgchart_other_versions: StringResource by lazy {
      StringResource("string:orgchart_other_versions", "orgchart_other_versions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55908, 51),
      ))
    }

@delegate:ResourceContentHash(599_858_705)
internal val Res.string.orgchart_period: StringResource by lazy {
      StringResource("string:orgchart_period", "orgchart_period", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56016, 43),
      ))
    }

@delegate:ResourceContentHash(-1_370_652_442)
internal val Res.string.orgchart_period_until_today: StringResource by lazy {
      StringResource("string:orgchart_period_until_today", "orgchart_period_until_today", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55960, 55),
      ))
    }

@delegate:ResourceContentHash(1_522_200_397)
internal val Res.string.orgchart_previous_versions: StringResource by lazy {
      StringResource("string:orgchart_previous_versions", "orgchart_previous_versions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56060, 62),
      ))
    }

@delegate:ResourceContentHash(2_103_720_444)
internal val Res.string.orgchart_publish_action: StringResource by lazy {
      StringResource("string:orgchart_publish_action", "orgchart_publish_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56123, 43),
      ))
    }

@delegate:ResourceContentHash(-2_046_974_263)
internal val Res.string.orgchart_publish_empty: StringResource by lazy {
      StringResource("string:orgchart_publish_empty", "orgchart_publish_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56167, 98),
      ))
    }

@delegate:ResourceContentHash(1_877_653_646)
internal val Res.string.orgchart_publish_success: StringResource by lazy {
      StringResource("string:orgchart_publish_success", "orgchart_publish_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56266, 92),
      ))
    }

@delegate:ResourceContentHash(223_665_034)
internal val Res.string.orgchart_publish_support: StringResource by lazy {
      StringResource("string:orgchart_publish_support", "orgchart_publish_support", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56359, 68),
      ))
    }

@delegate:ResourceContentHash(1_969_067_511)
internal val Res.string.orgchart_publish_version: StringResource by lazy {
      StringResource("string:orgchart_publish_version", "orgchart_publish_version", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56428, 56),
      ))
    }

@delegate:ResourceContentHash(402_271_591)
internal val Res.string.orgchart_register_company: StringResource by lazy {
      StringResource("string:orgchart_register_company", "orgchart_register_company", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56485, 65),
      ))
    }

@delegate:ResourceContentHash(1_326_319_229)
internal val Res.string.orgchart_register_director: StringResource by lazy {
      StringResource("string:orgchart_register_director", "orgchart_register_director", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56551, 66),
      ))
    }

@delegate:ResourceContentHash(-1_346_762_873)
internal val Res.string.orgchart_register_manager: StringResource by lazy {
      StringResource("string:orgchart_register_manager", "orgchart_register_manager", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56618, 65),
      ))
    }

@delegate:ResourceContentHash(-936_695_728)
internal val Res.string.orgchart_remove_company: StringResource by lazy {
      StringResource("string:orgchart_remove_company", "orgchart_remove_company", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56780, 51),
      ))
    }

@delegate:ResourceContentHash(575_619_340)
internal val Res.string.orgchart_remove_company_msg: StringResource by lazy {
      StringResource("string:orgchart_remove_company_msg", "orgchart_remove_company_msg", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56684, 95),
      ))
    }

@delegate:ResourceContentHash(-553_778_308)
internal val Res.string.orgchart_remove_director: StringResource by lazy {
      StringResource("string:orgchart_remove_director", "orgchart_remove_director", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56929, 56),
      ))
    }

@delegate:ResourceContentHash(-777_624_579)
internal val Res.string.orgchart_remove_director_msg: StringResource by lazy {
      StringResource("string:orgchart_remove_director_msg", "orgchart_remove_director_msg", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56832, 96),
      ))
    }

@delegate:ResourceContentHash(1_285_232_721)
internal val Res.string.orgchart_remove_manager: StringResource by lazy {
      StringResource("string:orgchart_remove_manager", "orgchart_remove_manager", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57082, 51),
      ))
    }

@delegate:ResourceContentHash(1_345_253_935)
internal val Res.string.orgchart_remove_manager_msg: StringResource by lazy {
      StringResource("string:orgchart_remove_manager_msg", "orgchart_remove_manager_msg", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56986, 95),
      ))
    }

@delegate:ResourceContentHash(127_877_953)
internal val Res.string.orgchart_responsible_no_director: StringResource by lazy {
      StringResource("string:orgchart_responsible_no_director", "orgchart_responsible_no_director", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57134, 68),
      ))
    }

@delegate:ResourceContentHash(-786_943_736)
internal val Res.string.orgchart_responsible_pair: StringResource by lazy {
      StringResource("string:orgchart_responsible_pair", "orgchart_responsible_pair", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57203, 49),
      ))
    }

@delegate:ResourceContentHash(1_353_865_830)
internal val Res.string.orgchart_save: StringResource by lazy {
      StringResource("string:orgchart_save", "orgchart_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57301, 29),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString8Resources(map: MutableMap<String, StringResource>) {
  map.put("operational_supplier_title_add", Res.string.operational_supplier_title_add)
  map.put("operational_supplier_title_edit", Res.string.operational_supplier_title_edit)
  map.put("operational_supplier_use_existing", Res.string.operational_supplier_use_existing)
  map.put("operational_supplier_use_new", Res.string.operational_supplier_use_new)
  map.put("operational_table_faturamento", Res.string.operational_table_faturamento)
  map.put("operational_total_label", Res.string.operational_total_label)
  map.put("operational_type_label", Res.string.operational_type_label)
  map.put("operational_type_planned", Res.string.operational_type_planned)
  map.put("operational_type_real", Res.string.operational_type_real)
  map.put("operational_under_construction", Res.string.operational_under_construction)
  map.put("operational_units_empty", Res.string.operational_units_empty)
  map.put("operational_updated_info", Res.string.operational_updated_info)
  map.put("operational_week_format", Res.string.operational_week_format)
  map.put("orgchart_add", Res.string.orgchart_add)
  map.put("orgchart_add_company", Res.string.orgchart_add_company)
  map.put("orgchart_add_director", Res.string.orgchart_add_director)
  map.put("orgchart_add_manager", Res.string.orgchart_add_manager)
  map.put("orgchart_back_to_current", Res.string.orgchart_back_to_current)
  map.put("orgchart_cancel", Res.string.orgchart_cancel)
  map.put("orgchart_cell_evt", Res.string.orgchart_cell_evt)
  map.put("orgchart_cell_loj", Res.string.orgchart_cell_loj)
  map.put("orgchart_cell_tra", Res.string.orgchart_cell_tra)
  map.put("orgchart_cell_upr", Res.string.orgchart_cell_upr)
  map.put("orgchart_change_company_added", Res.string.orgchart_change_company_added)
  map.put("orgchart_change_company_linked_director", Res.string.orgchart_change_company_linked_director)
  map.put("orgchart_change_company_linked_directors", Res.string.orgchart_change_company_linked_directors)
  map.put("orgchart_change_company_linked_organogram", Res.string.orgchart_change_company_linked_organogram)
  map.put("orgchart_change_company_managed", Res.string.orgchart_change_company_managed)
  map.put("orgchart_change_company_managed_in_director", Res.string.orgchart_change_company_managed_in_director)
  map.put("orgchart_change_company_managed_in_directors", Res.string.orgchart_change_company_managed_in_directors)
  map.put("orgchart_change_company_removed", Res.string.orgchart_change_company_removed)
  map.put("orgchart_change_company_stopped_managed", Res.string.orgchart_change_company_stopped_managed)
  map.put("orgchart_change_company_stopped_managed_in_director", Res.string.orgchart_change_company_stopped_managed_in_director)
  map.put("orgchart_change_company_stopped_managed_in_directors", Res.string.orgchart_change_company_stopped_managed_in_directors)
  map.put("orgchart_change_company_unlinked_director", Res.string.orgchart_change_company_unlinked_director)
  map.put("orgchart_change_company_unlinked_organogram", Res.string.orgchart_change_company_unlinked_organogram)
  map.put("orgchart_change_director_added", Res.string.orgchart_change_director_added)
  map.put("orgchart_change_director_removed", Res.string.orgchart_change_director_removed)
  map.put("orgchart_change_manager_added", Res.string.orgchart_change_manager_added)
  map.put("orgchart_change_manager_removed", Res.string.orgchart_change_manager_removed)
  map.put("orgchart_change_manager_responds", Res.string.orgchart_change_manager_responds)
  map.put("orgchart_change_manager_responds_all", Res.string.orgchart_change_manager_responds_all)
  map.put("orgchart_change_manager_stopped", Res.string.orgchart_change_manager_stopped)
  map.put("orgchart_changes_draft_title", Res.string.orgchart_changes_draft_title)
  map.put("orgchart_changes_info_title", Res.string.orgchart_changes_info_title)
  map.put("orgchart_close", Res.string.orgchart_close)
  map.put("orgchart_company_actions", Res.string.orgchart_company_actions)
  map.put("orgchart_comparing", Res.string.orgchart_comparing)
  map.put("orgchart_confirm", Res.string.orgchart_confirm)
  map.put("orgchart_copy_company", Res.string.orgchart_copy_company)
  map.put("orgchart_copy_manager", Res.string.orgchart_copy_manager)
  map.put("orgchart_copy_support", Res.string.orgchart_copy_support)
  map.put("orgchart_copy_to", Res.string.orgchart_copy_to)
  map.put("orgchart_copy_to_director", Res.string.orgchart_copy_to_director)
  map.put("orgchart_create_version", Res.string.orgchart_create_version)
  map.put("orgchart_director_actions", Res.string.orgchart_director_actions)
  map.put("orgchart_director_subtitle", Res.string.orgchart_director_subtitle)
  map.put("orgchart_discard_action", Res.string.orgchart_discard_action)
  map.put("orgchart_discard_draft", Res.string.orgchart_discard_draft)
  map.put("orgchart_discard_draft_msg", Res.string.orgchart_discard_draft_msg)
  map.put("orgchart_empty_result", Res.string.orgchart_empty_result)
  map.put("orgchart_export", Res.string.orgchart_export)
  map.put("orgchart_legend_events", Res.string.orgchart_legend_events)
  map.put("orgchart_legend_kitchens", Res.string.orgchart_legend_kitchens)
  map.put("orgchart_legend_stores", Res.string.orgchart_legend_stores)
  map.put("orgchart_legend_transported", Res.string.orgchart_legend_transported)
  map.put("orgchart_manage_supervisors", Res.string.orgchart_manage_supervisors)
  map.put("orgchart_manager_actions", Res.string.orgchart_manager_actions)
  map.put("orgchart_mark_all_companies", Res.string.orgchart_mark_all_companies)
  map.put("orgchart_move_companies_too", Res.string.orgchart_move_companies_too)
  map.put("orgchart_new_version", Res.string.orgchart_new_version)
  map.put("orgchart_new_version_body", Res.string.orgchart_new_version_body)
  map.put("orgchart_no_changes_previous", Res.string.orgchart_no_changes_previous)
  map.put("orgchart_no_companies", Res.string.orgchart_no_companies)
  map.put("orgchart_no_director_option", Res.string.orgchart_no_director_option)
  map.put("orgchart_no_previous", Res.string.orgchart_no_previous)
  map.put("orgchart_not_found_company", Res.string.orgchart_not_found_company)
  map.put("orgchart_not_found_director", Res.string.orgchart_not_found_director)
  map.put("orgchart_not_found_manager", Res.string.orgchart_not_found_manager)
  map.put("orgchart_other_versions", Res.string.orgchart_other_versions)
  map.put("orgchart_period", Res.string.orgchart_period)
  map.put("orgchart_period_until_today", Res.string.orgchart_period_until_today)
  map.put("orgchart_previous_versions", Res.string.orgchart_previous_versions)
  map.put("orgchart_publish_action", Res.string.orgchart_publish_action)
  map.put("orgchart_publish_empty", Res.string.orgchart_publish_empty)
  map.put("orgchart_publish_success", Res.string.orgchart_publish_success)
  map.put("orgchart_publish_support", Res.string.orgchart_publish_support)
  map.put("orgchart_publish_version", Res.string.orgchart_publish_version)
  map.put("orgchart_register_company", Res.string.orgchart_register_company)
  map.put("orgchart_register_director", Res.string.orgchart_register_director)
  map.put("orgchart_register_manager", Res.string.orgchart_register_manager)
  map.put("orgchart_remove_company", Res.string.orgchart_remove_company)
  map.put("orgchart_remove_company_msg", Res.string.orgchart_remove_company_msg)
  map.put("orgchart_remove_director", Res.string.orgchart_remove_director)
  map.put("orgchart_remove_director_msg", Res.string.orgchart_remove_director_msg)
  map.put("orgchart_remove_manager", Res.string.orgchart_remove_manager)
  map.put("orgchart_remove_manager_msg", Res.string.orgchart_remove_manager_msg)
  map.put("orgchart_responsible_no_director", Res.string.orgchart_responsible_no_director)
  map.put("orgchart_responsible_pair", Res.string.orgchart_responsible_pair)
  map.put("orgchart_save", Res.string.orgchart_save)
}
